var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOphos = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 530,
    viewBox: "0 0 451 530",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ophos-image-a",
    width: "129.3%",
    height: "254.3%",
    x: "-14.6%",
    y: "-77.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 18
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ophos-image-b",
    width: "131.5%",
    height: "119.3%",
    x: "-15.8%",
    y: "-9.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(42 14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M205.234614,471 C320.078315,471 369,434.360354 369,418.206813 C369,402.053272 320.078315,404.502133 205.234614,404.502133 C90.3909123,404.502133 0,390.595254 0,418.206813 C0,445.818372 90.3909123,471 205.234614,471 Z",
    filter: "url(#ophos-image-a)",
    opacity: 0.618
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ophos-image-b)",
    transform: "translate(32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M184.798266,293.852699 L187.088681,279.195182 L212.275819,213.803904 L218,189 L42,189 L47.7260369,213.803904 L72.9131751,279.195182 L75.2017338,293.852699 L80.9259146,332.186337 L92.947808,371.082953 L89.5121859,403.214701 L70.6227603,408.851785 C64.3250477,417.872217 74.0565264,419 74.0565264,419 L100.962404,414.490698 L99.2436645,403.214701 L105.827215,378.975602 L99.2436645,371.64593 L110.339369,338.391883 L121.305147,325.624361 C121.305147,324.619045 122.140388,323.796513 123.161237,323.796513 L135.92371,323.796513 C136.94456,323.796513 137.7798,324.619045 137.7798,325.624361 L147.960453,338.391883 L159.056157,371.64593 L152.472607,378.975602 L159.056157,403.214701 L159.312298,403.214701 L157.593559,414.490698 L184.499436,419 C184.499436,419 194.229058,417.872217 187.933202,408.851785 L169.04192,403.214701 L168.787636,403.214701 L165.352014,371.082953 L177.373907,332.186337 L184.798266,293.852699 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M184.798266,293.852699 L187.088681,279.195182 L212.275819,213.803904 L218,189 L42,189 L47.7260369,213.803904 L72.9131751,279.195182 L75.2017338,293.852699 L80.9259146,332.186337 L92.947808,371.082953 L89.5121859,403.214701 L70.6227603,408.851785 C64.3250477,417.872217 74.0565264,419 74.0565264,419 L100.962404,414.490698 L99.2436645,403.214701 L105.827215,378.975602 L99.2436645,371.64593 L110.339369,338.391883 L121.305147,325.624361 C121.305147,324.619045 122.140388,323.796513 123.161237,323.796513 L135.92371,323.796513 C136.94456,323.796513 137.7798,324.619045 137.7798,325.624361 L147.960453,338.391883 L159.056157,371.64593 L152.472607,378.975602 L159.056157,403.214701 L159.312298,403.214701 L157.593559,414.490698 L184.499436,419 C184.499436,419 194.229058,417.872217 187.933202,408.851785 L169.04192,403.214701 L168.787636,403.214701 L165.352014,371.082953 L177.373907,332.186337 L184.798266,293.852699 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF2729",
    d: "M161,256 L132,192"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "217.455 159 205.953 159 127.1 183.653 54.047 159 42.545 159 42 188.828 47.721 213.591 72.897 278.874 128.955 314 187.105 278.874 212.279 213.591 218 188.828"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "217.455 159 205.953 159 127.1 183.653 54.047 159 42.545 159 42 188.828 47.721 213.591 72.897 278.874 128.955 314 187.105 278.874 212.279 213.591 218 188.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M75,100.5 C75,119.554803 67.6121613,135 58.4990744,135 C49.3859875,135 42,119.554803 42,100.5 C42,81.445197 49.3859875,66 58.4990744,66 C67.6121613,66 75,81.445197 75,100.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M75,100.5 C75,119.554803 67.6121613,135 58.4990744,135 C49.3859875,135 42,119.554803 42,100.5 C42,81.445197 49.3859875,66 58.4990744,66 C67.6121613,66 75,81.445197 75,100.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M218,100.5 C218,119.554803 210.612161,135 201.499074,135 C192.385988,135 185,119.554803 185,100.5 C185,81.445197 192.385988,66 201.499074,66 C210.612161,66 218,81.445197 218,100.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M218,100.5 C218,119.554803 210.612161,135 201.499074,135 C192.385988,135 185,119.554803 185,100.5 C185,81.445197 192.385988,66 201.499074,66 C210.612161,66 218,81.445197 218,100.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141415",
    d: "M210.859877,96.1182679 C196.482099,152.966291 186.90125,215.416787 130.709713,215.997297 C82.8519345,216.490184 65.7643843,149.4668 50.5595498,96.1182679 C35.9884824,44.9986763 86.4426618,0 130.709713,0 C174.974906,0 223.888344,44.5988909 210.859877,96.1182679"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M210.859877,96.1182679 C196.482099,152.966291 186.90125,215.416787 130.709713,215.997297 C82.8519345,216.490184 65.7643843,149.4668 50.5595498,96.1182679 C35.9884824,44.9986763 86.4426618,0 130.709713,0 C174.974906,0 223.888344,44.5988909 210.859877,96.1182679 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D33",
    d: "M190.391682,115.428729 C179.586953,161.222156 172.3869,211.529423 130.157505,211.997823 C94.1925826,212.394865 81.3511561,158.404437 69.9233281,115.428729 C58.9735196,74.2497752 96.8914398,38 130.157505,38 C163.42357,38 200.182711,73.9277501 190.391682,115.428729"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C556C",
    d: "M81.1756381,47 C94.0978171,33.9549534 111.43087,25.9637947 130.499076,25.9637947 C149.56913,25.9637947 166.902183,33.9549534 179.824362,47 L192,47 C179.236738,21.7918306 156.470937,5 130.499076,5 C104.529063,5 81.7632619,21.7918306 69,47 L81.1756381,47 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "224.671 232.479 218 265 231.071 265 243 226"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "224.671 232.479 218 265 231.071 265 243 226"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "32.329 232.479 39 265 25.929 265 14 226"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "32.329 232.479 39 265 25.929 265 14 226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M49.6277429,272.603067 C53.9325737,281.502993 52.2162809,291.13399 45.7947516,294.115364 C39.3732222,297.096737 30.677088,292.297812 26.3722571,283.396045 C22.0674263,274.49612 23.7837191,264.865123 30.2052484,261.883749 C36.6267778,258.904217 45.322912,263.703142 49.6277429,272.603067"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M49.6277429,272.603067 C53.9325737,281.502993 52.2162809,291.13399 45.7947516,294.115364 C39.3732222,297.096737 30.677088,292.297812 26.3722571,283.396045 C22.0674263,274.49612 23.7837191,264.865123 30.2052484,261.883749 C36.6267778,258.904217 45.322912,263.703142 49.6277429,272.603067 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M208.372257,272.603067 C204.067426,281.502993 205.783719,291.13399 212.205248,294.115364 C218.626778,297.096737 227.322912,292.297812 231.627743,283.396045 C235.932574,274.49612 234.216281,264.865123 227.794752,261.883749 C221.373222,258.904217 212.677088,263.703142 208.372257,272.603067"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M208.372257,272.603067 C204.067426,281.502993 205.783719,291.13399 212.205248,294.115364 C218.626778,297.096737 227.322912,292.297812 231.627743,283.396045 C235.932574,274.49612 234.216281,264.865123 227.794752,261.883749 C221.373222,258.904217 212.677088,263.703142 208.372257,272.603067 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "206 159.336 218.156 151.287 248.299 133 248.299 196.528 260 219.862 211.791 237 206 230.479"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "206 159.336 218.156 151.287 248.299 133 248.299 196.528 260 219.862 211.791 237 206 230.479"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "54 159.336 41.844 151.287 11.701 133 11.701 196.528 0 219.862 48.209 237 54 230.479"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "54 159.336 41.844 151.287 11.701 133 11.701 196.528 0 219.862 48.209 237 54 230.479"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "86.059 354 82 369.219 88.41 380.395 103.585 386 106 378.922 103.107 358.536"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "86.059 354 82 369.219 88.41 380.395 103.585 386 106 378.922 103.107 358.536"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "171.941 354 176 369.219 169.59 380.395 154.415 386 152 378.922 154.893 358.536"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "171.941 354 176 369.219 169.59 380.395 154.415 386 152 378.922 154.893 358.536"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M48 69L67.8982645 94.0244659C67.8982645 94.0244659 98.5870842 73.9214051 105.974962 87.3289382 105.974962 87.3289382 121.26112 127.194516 98.5112637 193M211 69L191.101735 94.0244659C191.101735 94.0244659 160.412916 73.9214051 153.025038 87.3289382 153.025038 87.3289382 137.73888 127.194516 160.488736 193"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOphos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ophos.34c8ef7c.svg";
export { ForwardRef as ReactComponent };